import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolTip = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 6,
				cy: 6,
				r: 6,
				fill: "#E0F2F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0176C8",
				d: "M5 5h2v5H5z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 6,
				cy: 3,
				r: 1,
				fill: "#0176C8"
			})
		]
	})
});
export default SvgToolTip;
